import { useQuery } from '@provision/graphql-client';
import { GET_ACTIVATION_FLOW_CONFIG_QUERY } from 'src/graphql/entities/activation-flow-config/activation-flow-config.operations';
import type {
  GetActivationFlowConfigQueryData,
  GetActivationFlowConfigQueryVariables,
} from 'src/graphql/entities/activation-flow-config/activation-flow-config.types';

interface UseGetTosUrlParams {
  partnerId?: number;
  brandId?: string;
}

interface UseGetTosUrlResult {
  tosUrl: string;
  privacyPolicyUrl: string;
  loading: boolean;
}

export const useGetTosUrl = ({ partnerId, brandId }: UseGetTosUrlParams): UseGetTosUrlResult => {
  const shouldQuery = !!partnerId && !!brandId;

  const { data, loading } = useQuery<
    GetActivationFlowConfigQueryData,
    GetActivationFlowConfigQueryVariables
  >(GET_ACTIVATION_FLOW_CONFIG_QUERY, {
    variables: {
      input: {
        partnerId: String(partnerId ?? ''),
        brandId: brandId ?? '',
      },
    },
    skip: !shouldQuery,
    fetchPolicy: 'cache-first',
  });

  const options = data?.getBundledActivationFlowConfig?.options;

  return {
    tosUrl: options?.termsOfServiceUrl || '',
    privacyPolicyUrl: options?.privacyPolicyUrl || '',
    loading: shouldQuery && loading,
  };
};
